import LocalSettings from './localSettings';
const getRoot = state => state.settings;
export const getSettings = state => getRoot(state).settings;
export const getSettingsLastFetched = state => getRoot(state).lastFetched;
export const getSettingsRequestState = state => getRoot(state).requestState;
export const isFormLabelPropertyEnabled = () => LocalSettings.get('propertylabels:enabled') || false;